import { useState } from "react";
import { useTranslation } from "react-i18next";
import Icon from "../components/Icon";
import Modal from "../components/Modal";
import Reveal from "../components/Reveal";
import SectionHead from "../components/SectionHead";
import { GALLERY_IMAGES } from "../data/gallery";

export default function Gallery() {
  const { t } = useTranslation();
  const [selectedIndex, setSelectedIndex] = useState(null);
  const selected = selectedIndex === null ? null : GALLERY_IMAGES[selectedIndex];

  const move = (direction) => {
    setSelectedIndex((current) => {
      if (current === null) return null;
      return (current + direction + GALLERY_IMAGES.length) % GALLERY_IMAGES.length;
    });
  };

  return (
    <section className="fsg-section fsg-gallery-section" id="galeria">
      <div className="fsg-container">
        <SectionHead
          eyebrow={t("gallery.eyebrow")}
          title={t("gallery.title")}
          lead={t("gallery.lead")}
          center
        />
      </div>

      <div className="fsg-gallery-shell">
        <div className="fsg-gallery">
          {GALLERY_IMAGES.map((image, index) => (
            <Reveal
              className={`fsg-gallery__item ${image.featured ? "is-featured" : ""}`}
              key={image.id}
              delay={(index % 8) * 35}
            >
              <button
                type="button"
                onClick={() => setSelectedIndex(index)}
                aria-label={`${t("gallery.openPhoto")} ${index + 1}`}
              >
                <img
                  src={image.src}
                  alt={`${t("gallery.photoAlt")} ${index + 1}`}
                  loading="lazy"
                  decoding="async"
                />
                <span className="fsg-gallery__zoom" aria-hidden="true">
                  <Icon name="search" />
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <Modal
        open={selected !== null}
        onClose={() => setSelectedIndex(null)}
        title={
          selectedIndex === null
            ? t("gallery.title")
            : `${t("gallery.title")} · ${selectedIndex + 1} ${t("gallery.of")} ${GALLERY_IMAGES.length}`
        }
        size="lg"
      >
        {selected && (
          <div className="fsg-gallery-viewer">
            <img
              src={selected.src}
              alt={`${t("gallery.photoAlt")} ${selectedIndex + 1}`}
            />
            <div className="fsg-gallery-viewer__nav">
              <button
                type="button"
                className="fsg-btn fsg-btn--ghost"
                onClick={() => move(-1)}
              >
                <Icon name="arrow" className="is-back" />
                {t("gallery.previous")}
              </button>
              <button
                type="button"
                className="fsg-btn fsg-btn--ghost"
                onClick={() => move(1)}
              >
                {t("gallery.next")}
                <Icon name="arrow" />
              </button>
            </div>
          </div>
        )}
      </Modal>
    </section>
  );
}
